import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor, FormControl } from '@angular/forms';
import { BtDropdownModel } from '../bt-dropdown.model';

@Component({
    selector: 'bt-dropdown-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => BtDropdownFormComponent),
        multi: true
      },
      {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => BtDropdownFormComponent),
        multi: true
      }
    ],
    templateUrl: './bt-dropdown-form.component.html',
    styleUrls: ['./bt-dropdown-form.component.scss']
})
export class BtDropdownFormComponent implements ControlValueAccessor {
    @Input() model: BtDropdownModel;
    @Input() value: any;

    propagateChange = (_: any) => {};
    registerOnChange(fn: any) { this.propagateChange = fn; }
    registerOnTouched() {}
    writeValue(value: string) {
        this.value = value; 
    }

	validate({ value }: FormControl) {
		const isValid = (this.model as any).required && !value;
		return isValid && {
		  	invalid: true
		};
	}

  onValueChanged(event: any) {
    this.value = event.value;
    this.propagateChange(event.value);
  }
}